const portalLink = (app, page) => {
  const hostname = window.location.hostname;

  // const student = [
  //   'home',
  //   'profile',
  //   'links'
  // ]

  const staff = ['admin'];

  const type = staff.includes(app) ? 'staff' : 'student';

  let env = '';
  if (hostname.includes('localhost') || hostname.includes('dev')) {
    env = '-dev';
  }
  if (hostname.includes('qa')) {
    env = '-qa';
  }

  return `https://${app}.${type}${env}.monash${page ? '/' + page : ''}`;
};

export default portalLink;
